
















































































































import { Component, PropSync, Vue } from 'vue-property-decorator';
import StepScheduleReminderPocketViewModel from '@/vue-app/view-models/components/flagship/flagship-link-goals/steps-pocket/step-schedule-reminder-pocket-view-model';

@Component({ name: 'StepScheduleReminderPocket' })
export default class StepScheduleReminderPocket extends Vue {
  @PropSync('associatedProductId', { type: String, required: true })
  associated_product_id!: string;

  @PropSync('investorGoals', { type: Object, required: true })
  investor_goal!: Record<string, any>;

  @PropSync('isLoading', { type: Boolean, required: true, default: false })
  is_loading!: boolean;

  step_schedule_reminder_pocket_model = Vue.observable(
    new StepScheduleReminderPocketViewModel(this),
  );

  created() {
    this.step_schedule_reminder_pocket_model.initialize(
      this.associated_product_id,
      this.investor_goal,
    );
  }
}
